import { useEffect, useState } from "react";
import { supabase, callFunction } from "../lib/supabase.js";
import { Shell, Brand, ErrorText, Label, Loading, Message } from "./common.jsx";

export function AcceptInvite({ token }) {
  const [info, setInfo] = useState(undefined);
  const [loadErr, setLoadErr] = useState("");
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  useEffect(() => {
    callFunction("team", { action: "invite-info", token }).then(setInfo).catch(e => { setLoadErr(e.message); setInfo(null); });
  }, [token]);

  const accept = async e => {
    e.preventDefault();
    if (!info.existingAccount && pw.length < 8) { setErr("Choose a password with at least 8 characters."); return; }
    setBusy(true); setErr("");
    try {
      if (info.existingAccount) {
        // Prove it's them first, then join with their signed-in session.
        const { error } = await supabase.auth.signInWithPassword({ email: info.email, password: pw });
        if (error) throw new Error(/invalid/i.test(error.message) ? "That password doesn't match this account." : error.message);
        await callFunction("team", { action: "accept", token });
      } else {
        await callFunction("team", { action: "accept", token, password: pw, name: name.trim() });
        const { error } = await supabase.auth.signInWithPassword({ email: info.email, password: pw });
        if (error) throw error;
      }
      location.href = "/";
    } catch (x) {
      setErr(x.message || "Couldn't accept the invite.");
      setBusy(false);
    }
  };

  if (info === undefined) return <Loading />;
  if (!info) return <Message title="Invite unavailable" body={loadErr || "This invite link has expired or was already used. Ask the studio owner to send a new one."}><a href="/">Go to sign in</a></Message>;

  return (
    <Shell>
      <div>
        <Brand sub={"Join " + info.studioName} />
        <h1 className="display" style={{ fontSize: 38, margin: "10px 0 0" }}>A seat at the desk.</h1>
      </div>
      <div style={{ fontSize: 17, lineHeight: 1.6 }}>
        You&rsquo;ve been invited as {info.role === "owner" ? "an owner" : "a planner"} for <strong style={{ fontWeight: 500 }}>{info.email}</strong>.
        {info.existingAccount ? " You already have an account — enter your password to join." : " Set your name and a password to finish."}
      </div>
      <form onSubmit={accept} style={{ display: "flex", flexDirection: "column", gap: 18 }}>
        {!info.existingAccount && <Label text="Your name"><input className="input" autoComplete="name" value={name} onChange={e => setName(e.target.value)} /></Label>}
        <Label text={info.existingAccount ? "Password" : "Choose a password"}><input className="input" type="password" autoComplete={info.existingAccount ? "current-password" : "new-password"} value={pw} onChange={e => setPw(e.target.value)} /></Label>
        <button className="btn btn-accent btn-block" disabled={busy} type="submit">{busy ? "Joining…" : "Join the studio"}</button>
        <ErrorText>{err}</ErrorText>
      </form>
    </Shell>
  );
}
